import { createTheme } from "@mui/material";

const mainTheme = createTheme({
    palette: {
      primary: {
        main: '#00072d',
        contrastText: '#fff',
      },
      secondary: {
        main: '#FF6700',
        contrastText: '#fff',
      },
      text: {
        primary: '#000000'
      }
    },
    typography: {
      fontFamily: [
        'Montserrat',
      ].join(','),
    },
  });

export default mainTheme